export const GET_ALL_AUCTION_CENTER = "GET_ALL_AUCTION_CENTER";
export const GET_ALL_AUCTION_CENTER_SUCCESS = "GET_ALL_AUCTION_CENTER_SUCCESS";
export const GET_ALL_AUCTION_CENTER_FAIL = "GET_ALL_AUCTION_CENTER_FAIL";

// Update Auction Center Actions
export const UPDATE_AUCTION_CENTER = "UPDATE_AUCTION_CENTER";
export const UPDATE_AUCTION_CENTER_SUCCESS = "UPDATE_AUCTION_CENTER_SUCCESS";
export const UPDATE_AUCTION_CENTER_FAIL = "UPDATE_AUCTION_CENTER_FAIL";

// Create Auction Center Actions
export const CREATE_AUCTION_CENTER = "CREATE_AUCTION_CENTER";
export const CREATE_AUCTION_CENTER_SUCCESS = "CREATE_AUCTION_CENTER_SUCCESS";
export const CREATE_AUCTION_CENTER_FAIL = "CREATE_AUCTION_CENTER_FAIL";

// Search Auction Center Actions
export const SEARCH_AUCTION_CENTER = "SEARCH_AUCTION_CENTER";
export const SEARCH_AUCTION_CENTER_SUCCESS = "SEARCH_AUCTION_CENTER_SUCCESS";
export const SEARCH_AUCTION_CENTER_FAIL = "SEARCH_AUCTION_CENTER_FAIL";


// Search Auction Center Actions
export const SEARCH_AUCTION_CENTER1 = "SEARCH_AUCTION_CENTER1";
export const SEARCH_AUCTION_CENTER_SUCCESS1 = "SEARCH_AUCTION_CENTER_SUCCESS1";
export const SEARCH_AUCTION_CENTER_FAIL1 = "SEARCH_AUCTION_CENTER_FAIL1";

// Get Auction Center by ID Actions
export const GET_AUCTION_CENTER_BY_ID = "GET_AUCTION_CENTER_BY_ID";
export const GET_AUCTION_CENTER_BY_ID_SUCCESS =
  "GET_AUCTION_CENTER_BY_ID_SUCCESS";
export const GET_AUCTION_CENTER_BY_ID_FAIL = "GET_AUCTION_CENTER_BY_ID_FAIL";

// Upload all documents
export const UPLOAD_ALL_DOCUMENTS_AUCTION_CENTER =
  "UPLOAD_ALL_DOCUMENTS_AUCTION_CENTER";
export const UPLOAD_ALL_DOCUMENTS_AUCTION_CENTER_SUCCESS =
  "UPLOAD_ALL_DOCUMENTS_AUCTION_CENTER_SUCCESS";
export const UPLOAD_ALL_DOCUMENTS_AUCTION_CENTER_FAIL =
  "UPLOAD_ALL_DOCUMENTS_AUCTION_CENTER_FAIL";

export const CREATE_EDIT_AUCTION_CENTER_API_STATUS =
  "CREATE_EDIT_AUCTION_CENTER_API_STATUS";

export const USER_WISE_AUCTION_CENTER_DETAILS =
  "USER_WISE_AUCTION_CENTER_DETAILS";
export const USER_WISE_AUCTION_CENTER_DETAILS_SUCCESS =
  "USER_WISE_AUCTION_CENTER_DETAILS_SUCCESS";
export const USER_WISE_AUCTION_CENTER_DETAILS_FAIL =
  "USER_WISE_AUCTION_CENTER_DETAILS_FAIL";

export const GET_ALL_AUCTION_REGION_CENTER = "GET_ALL_AUCTION_REGION_CENTER";
export const GET_ALL_AUCTION_REGION_CENTER_SUCCESS =
  "GET_ALL_AUCTION_REGION_CENTER_SUCCESS";
export const GET_ALL_AUCTION_REGION_CENTER_FAIL =
  "GET_ALL_AUCTION_REGION_CENTER_FAIL";

export const GET_ALL_AUCTION_CENTER_ASC = "GET_ALL_AUCTION_CENTER_ASC";
export const GET_ALL_AUCTION_CENTER_SUCCESS_ASC =
  "GET_ALL_AUCTION_CENTER_SUCCESS_ASC";
export const GET_ALL_AUCTION_CENTER_FAIL_ASC =
  "GET_ALL_AUCTION_CENTER_FAIL_ASC";

export const SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS =
  "SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS";
export const SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS_SUCCESS =
  "SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS_SUCCESS";
export const SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS_FAIL =
  "SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS_FAIL";

export const IS_SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS_SUCCESS =
  "IS_SUBMIT_UNMAPPED_AUCTION_CENTER_DETAILS_SUCCESS";

export const GET_SERVER_DATE_AND_TIME = "GET_SERVER_DATE_AND_TIME";
export const GET_SERVER_DATE_AND_TIME_SUCCESS =
  "GET_SERVER_DATE_AND_TIME_SUCCESS";

export const CREATE_AUCTION_CENTER_TYPE = "CREATE_AUCTION_CENTER_TYPE";
export const CREATE_AUCTION_CENTER_TYPE_SUCCESS =
  "CREATE_AUCTION_CENTER_TYPE_SUCCESS";
export const CREATE_AUCTION_CENTER_TYPE_FAIL =
  "CREATE_AUCTION_CENTER_TYPE_FAIL";

export const ACTIONCENTER_DISABLE = "ACTIONCENTER_DISABLE";

export const ACTIONCENTER_LOADER = "ACTIONCENTER_LOADER";
